export const SITE_LOGO_SRC = '/cloudtransfer.png';
export const SITE_LOGO_DARK_SRC = '/cloudtransfer_logo_darkmode.png';
export const SITE_LOGO_ALT = 'CloudTransfer';

/** Figma navbar logo (177.214 × 30) */
export const SITE_LOGO_NAVBAR_CLASS =
  'h-[30px] w-[177px] shrink-0 object-contain object-left';

export const SITE_LOGO_FOOTER_CLASS =
  'h-[28px] w-[177px] shrink-0 object-contain object-left lg:h-[30px]';

export const SITE_LOGO_AUTH_CLASS =
  'logo-image mt-[54px] ml-[42px] h-[30px] w-[177px] object-contain object-left';

export function resolveSiteLogoSrc(
  branding?: {logo_dark?: string; logo_light?: string} | null,
  isDarkMode = false,
): string {
  if (isDarkMode) {
    const fromSettings = branding?.logo_light;
    if (
      fromSettings &&
      !isLegacyLogoPath(fromSettings) &&
      !isLightLogoPath(fromSettings)
    ) {
      return normalizeLogoSrc(fromSettings);
    }
    return SITE_LOGO_DARK_SRC;
  }

  const fromSettings = branding?.logo_dark;
  if (fromSettings && !isLegacyLogoPath(fromSettings)) {
    return normalizeLogoSrc(fromSettings);
  }
  return SITE_LOGO_SRC;
}

function normalizeLogoSrc(path: string): string {
  if (path.startsWith('http') || path.startsWith('/')) {
    return path;
  }
  return `/${path}`;
}

function isLightLogoPath(path: string): boolean {
  return path === 'cloudtransfer.png' || path.endsWith('/cloudtransfer.png');
}

function isLegacyLogoPath(path: string): boolean {
  return (
    path.includes('figma-cloudtransfer-logo') ||
    path.includes('logo-dark.png') ||
    path.includes('logo-light.png') ||
    path.includes('9fd32775-0c31-4e18-b513-e20901f009aa')
  );
}
